import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "shorteval-motorcycle-form-component" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_select_component = _resolveComponent("select-component")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_select_component, {
          items: _ctx.store.getters[`form/${_ctx.FormGetters.GET_DATA}`].filters.value,
          title: '',
          name: 'fieldModelType',
          id: 'fieldModelType',
          "class-input": 'form-control fieldVehicle',
          placeholder: 'Modellausführung wählen ...',
          "default-title": 'Modellausführung',
          required: true,
          filter: true,
          "filter-property": ['selection', 'mainTypeForMotorcycles'],
          disabled: false
        }, null, 8, ["items", "placeholder"]),
        _createVNode(_component_select_component, {
          items: _ctx.store.getters[`form/${_ctx.FormGetters.GET_DATA}`].filters.value,
          title: '',
          name: 'fieldSubType',
          id: 'fieldSubType',
          "class-input": 'form-control fieldVehicle',
          placeholder: 'Modellversion wählen ...',
          "default-title": 'Modellversion',
          required: true,
          filter: true,
          "filter-property": ['selection', 'subTypeForMotorcycles'],
          disabled: false
        }, null, 8, ["items", "placeholder"]),
        _createVNode(_component_select_component, {
          items: _ctx.store.getters[`form/${_ctx.FormGetters.GET_DATA}`].filters.value,
          title: '',
          name: 'fieldEngine',
          id: 'fieldEngine',
          "class-input": 'form-control fieldVehicle',
          placeholder: 'Motor wählen ...',
          "default-title": 'Motor',
          required: true,
          filter: true,
          "filter-property": ['selection', 'engine'],
          disabled: false
        }, null, 8, ["items", "placeholder"]),
        _createVNode(_component_select_component, {
          items: _ctx.carsBelowThreshold,
          title: '',
          name: 'vehicleSelected',
          id: 'vehicleSelected',
          "class-input": 'form-control p-3',
          placeholder: 'Ausstattungslinie',
          "default-title": 'Ausstattungslinie',
          required: true,
          filter: false
        }, null, 8, ["items"])
      ])
    ])
  ]))
}